import React, { useEffect, useState } from 'react';
import styles from './MileageAnalysisTab_bus.module.css';
import useHttp from '../../../../hook/use-http';
import { API_URL_MAIN } from '../../../../constants/driveglobalfilterinitalstates_bus';
import ChartLoader from './ChartLoader'
import { useVehicleData } from './context';



function TooltipTableModal({ data, globalFilter, selectedVehicleData, benchmarkType }) {
  const { firstVinNo } = selectedVehicleData
  const { isLoading, error, sendReq: fetchData } = useHttp();
  const { key, label } = data
  const { GlobalData, setGlobalData, handleDownloadAllReport } = useVehicleData();



  const [vehicleData, setVehicleData] = useState({})


  const output = Object.entries(vehicleData).map(([label, values]) => ({
    label,
    ...values
  }));


  useEffect(() => {

    // let ApiUrl = key == 'vehicleSpeedDistribution' ? 'mileage_analysis_vehicle_speed_distribution_table' : 'mileage_analysis_accelaration_pedal_table'
    // let ApiUrl = key == 'vehicleSpeedDistribution' ? 'mileage_analysis_vehicle_speed_distribution_table' 

    let ApiUrl = ""
    let filterObj = {
      ...globalFilter,
      "VIN_NUM": [firstVinNo.vehicleId],
    }

    if (benchmarkType == "Custom") {
      let apis = {
        vehicleSpeedDistribution: 'mileage_analysis_vehicle_speed_distribution_table',
        accPedalPosition: 'mileage_analysis_accelaration_pedal_table',
        RPM: "mileage_analysis_RPM_table"

      }
      ApiUrl = apis[key] || ""
    }
    if (benchmarkType == "National") {
      // ApiUrl = key == 'vehicleSpeedDistribution' ? 'mileage_analysis_national_vehicle_speed_distribution_table' : 'mileage_analysis_national_accelaration_pedal_table'
      let apis = {
        vehicleSpeedDistribution: 'mileage_analysis_national_vehicle_speed_distribution_table',
        accPedalPosition: 'mileage_analysis_national_accelaration_pedal_table',
        RPM: "mileage_analysis_national_RPM_table"
      }
      ApiUrl = apis[key] || ""

      filterObj.NATIONAL_VIN_NUM = GlobalData?.nationalVehicleDetails?.vehicleId ? [GlobalData?.nationalVehicleDetails?.vehicleId] : []
    }
    if (benchmarkType == "Depot") {
      // ApiUrl = key == 'vehicleSpeedDistribution' ? 'mileage_analysis_depo_vehicle_speed_distribution_table' : 'mileage_analysis_depo_accelaration_pedal_table'
      let apis = {
        vehicleSpeedDistribution: 'mileage_analysis_depo_vehicle_speed_distribution_table',
        accPedalPosition: 'mileage_analysis_depo_accelaration_pedal_table',
        RPM: "mileage_analysis_depo_RPM_table"
      }
      ApiUrl = apis[key] || ""

      filterObj.DEPO_VIN_NUM = GlobalData?.depoVehicleDetails?.vehicleId ? [GlobalData?.depoVehicleDetails?.vehicleId] : []
    }
    setVehicleData([])
    fetchData(
      {
        url: API_URL_MAIN + `mileage_analysis/${ApiUrl}`,
        body: {
          filterdata: {
            ...filterObj
          }
        }
      },
      (res) => {

        let selectedDay = res?.selectedDay || {}
        let bestDay = res?.bastDay || res?.bestDay || {}
        let national = res?.national || {}
        let depo = res?.national || {}

        if (key == "vehicleSpeedDistribution") {

          setVehicleData(prevState => ({
            '0-20': { ...prevState['0-20'], primaryVehicle: Number(selectedDay?.Vehicle_Speed_Distribution_0_20?.value).toFixed(2) ?? null, bestVehicle: Number(bestDay?.Vehicle_Speed_Distribution_0_20?.value).toFixed(2) ?? null, national: Number(national?.Vehicle_Speed_Distribution_0_20?.value).toFixed(2) ?? null, depo: Number(depo?.Vehicle_Speed_Distribution_0_20?.value).toFixed(2) ?? null },
            '20-30': { ...prevState['20-30'], primaryVehicle: Number(selectedDay?.Vehicle_Speed_Distribution_20_30?.value).toFixed(2) ?? null, bestVehicle: Number(bestDay?.Vehicle_Speed_Distribution_20_30?.value).toFixed(2) ?? null, national: Number(national?.Vehicle_Speed_Distribution_20_30?.value).toFixed(2) ?? null, depo: Number(depo?.Vehicle_Speed_Distribution_20_30?.value).toFixed(2) ?? null },
            '30-50': { ...prevState['30-50'], primaryVehicle: Number(selectedDay?.Vehicle_Speed_Distribution_30_50?.value).toFixed(2) ?? null, bestVehicle: Number(bestDay?.Vehicle_Speed_Distribution_30_50?.value).toFixed(2) ?? null, national: Number(national?.Vehicle_Speed_Distribution_30_50?.value).toFixed(2) ?? null, depo: Number(depo?.Vehicle_Speed_Distribution_30_50?.value).toFixed(2) ?? null },
            '50-60': { ...prevState['50-60'], primaryVehicle: Number(selectedDay?.Vehicle_Speed_Distribution_50_60?.value).toFixed(2) ?? null, bestVehicle: Number(bestDay?.Vehicle_Speed_Distribution_50_60?.value).toFixed(2) ?? null, national: Number(national?.Vehicle_Speed_Distribution_50_60?.value).toFixed(2) ?? null, depo: Number(depo?.Vehicle_Speed_Distribution_50_60?.value).toFixed(2) ?? null },
            '60+': { ...prevState['60+'], primaryVehicle: Number(selectedDay?.["Vehicle_Speed_Distribution_60+"]?.value).toFixed(2) ?? null, bestVehicle: Number(bestDay?.["Vehicle_Speed_Distribution_60+"]?.value).toFixed(2) ?? null, national: Number(national?.["Vehicle_Speed_Distribution_60+"]?.value).toFixed(2) ?? null, depo: Number(depo?.["Vehicle_Speed_Distribution_60+"]?.value).toFixed(2) ?? null },
          }));
        }
        else if (key == "accPedalPosition") {

          setVehicleData(prevState => ({
            '0-20': { ...prevState['0-20'], primaryVehicle: Number(selectedDay?.selected_Accelarator_Pedal_0_20?.value).toFixed(2) ?? null, bestVehicle: Number(bestDay?.best_Accelarator_Pedal_0_20?.value).toFixed(2) ?? null, national: Number(national?.selected_Accelarator_Pedal_0_20?.value).toFixed(2) ?? null, depo: Number(depo?.selected_Accelarator_Pedal_0_20?.value).toFixed(2) ?? null, },
            '20-40': { ...prevState['20-40'], primaryVehicle: Number(selectedDay?.selected_Accelarator_Pedal_20_40?.value).toFixed(2) ?? null, bestVehicle: Number(bestDay?.best_Accelarator_Pedal_20_40?.value).toFixed(2) ?? null, national: Number(national?.selected_Accelarator_Pedal_20_40?.value).toFixed(2) ?? null, depo: Number(depo?.selected_Accelarator_Pedal_20_40?.value).toFixed(2) ?? null, },
            '40-60': { ...prevState['40-60'], primaryVehicle: Number(selectedDay?.selected_Accelarator_Pedal_40_60?.value).toFixed(2) ?? null, bestVehicle: Number(bestDay?.best_Accelarator_Pedal_40_60?.value).toFixed(2) ?? null, national: Number(national?.selected_Accelarator_Pedal_40_60?.value).toFixed(2) ?? null, depo: Number(depo?.selected_Accelarator_Pedal_40_60?.value).toFixed(2) ?? null, },
            '60+': { ...prevState['60+'], primaryVehicle: Number(selectedDay?.selected_Accelarator_Pedal_60_plus?.value).toFixed(2) ?? null, bestVehicle: Number(bestDay?.best_Accelarator_Pedal_60_plus?.value).toFixed(2) ?? null, national: Number(national?.selected_Accelarator_Pedal_60_plus?.value).toFixed(2) ?? null, depo: Number(depo?.selected_Accelarator_Pedal_60_plus?.value).toFixed(2) ?? null, },
          }));

        }
        else {
          setVehicleData(prevState => ({
            '0-1000': { ...prevState['0-1000'], primaryVehicle: Number(selectedDay?.RPM_0_1000?.value).toFixed(2) ?? null, bestVehicle: Number(bestDay?.RPM_0_1000?.value).toFixed(2) ?? null, national: Number(national?.RPM_0_1000?.value).toFixed(2) ?? null, depo: Number(depo?.RPM_0_1000?.value).toFixed(2) ?? null, },
            '1000-2000': { ...prevState['1000-2000'], primaryVehicle: Number(selectedDay?.RPM_1000_2000?.value).toFixed(2) ?? null, bestVehicle: Number(bestDay?.RPM_1000_2000?.value).toFixed(2) ?? null, national: Number(national?.RPM_1000_2000?.value).toFixed(2) ?? null, depo: Number(depo?.RPM_1000_2000?.value).toFixed(2) ?? null, },
            '2000-3000': { ...prevState['2000-3000'], primaryVehicle: Number(selectedDay?.RPM_2000_3000?.value).toFixed(2) ?? null, bestVehicle: Number(bestDay?.RPM_2000_3000?.value).toFixed(2) ?? null, national: Number(national?.RPM_2000_3000?.value).toFixed(2) ?? null, depo: Number(depo?.RPM_2000_3000?.value).toFixed(2) ?? null, },
            '3000-4000': { ...prevState['3000-4000'], primaryVehicle: Number(selectedDay?.RPM_3000_4000?.value).toFixed(2) ?? null, bestVehicle: Number(bestDay?.RPM_3000_4000?.value).toFixed(2) ?? null, national: Number(national?.RPM_3000_4000?.value).toFixed(2) ?? null, depo: Number(depo?.RPM_3000_4000?.value).toFixed(2) ?? null, },
            '4000+': { ...prevState['4000+'], primaryVehicle: Number(selectedDay?.RPM_4000_plus?.value).toFixed(2) ?? null, bestVehicle: Number(bestDay?.RPM_4000_plus?.value).toFixed(2) ?? null, national: Number(national?.RPM_4000_plus?.value).toFixed(2) ?? null, depo: Number(depo?.RPM_4000_plus?.value).toFixed(2) ?? null, },
          }));
        }
        //0-1000, 1000-2000, 2000-3000, 3000-4000, 4000+
      }
    );


  }, [globalFilter, GlobalData?.depoVehicleDetails?.vehicleId, GlobalData?.nationalVehicleDetails?.vehicleId, firstVinNo, key, benchmarkType])


  return (
    <div>
      <div id="tooltipModal_MSbus" className="modal fade" role="dialog">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title text-capitalize">{label}</h5>
              <button type="button" className="close" data-dismiss="modal">
                &times;
              </button>
            </div>
            <div className="modal-body p-0" >
              <div className={styles.tooltipTableContainer} style={{ overflowY: "scroll", height: "300px", position: 'relative' }}>
                <table className={`table table-striped ${styles.tooltipTable}`}>
                  <thead>
                    <tr className={styles.tooltipTableHeader}>
                      <th className={styles.tooltipTableHeaderCell}>Sr. No.</th>
                      <th className={styles.tooltipTableHeaderCell}>{label}</th>
                      <th className={styles.tooltipTableHeaderCell}>Selected Vehicle</th>
                      <th className={styles.tooltipTableHeaderCell}>Best Driven Day</th>
                      {benchmarkType === 'National' && (
                        <th className={styles.tooltipTableHeaderCell}>National</th>
                      )}
                      {benchmarkType === 'Depot' && (
                        <th className={styles.tooltipTableHeaderCell}>&nbsp;&nbsp;&nbsp;Depot&nbsp;&nbsp;&nbsp;</th>
                      )}
                    </tr>
                  </thead>
                  <tbody>
                    {isLoading ? <ChartLoader /> : output?.map((item, index) => (
                      <tr key={index}>
                        <td className={styles.tooltipTableCell}>{index + 1}</td>
                        <td className={styles.tooltipTableCell}>{item.label}</td>
                        <td className={`${styles.tooltipTableCell} ${styles.tooltipValueCell}`}>
                          {item?.primaryVehicle && !isNaN(item?.primaryVehicle) ? <>{item.primaryVehicle + " %"}</> : "NA"}
                        </td>
                        <td className={`${styles.tooltipTableCell} ${styles.tooltipValueCell}`}>
                          {item?.bestVehicle && !isNaN(item?.bestVehicle) ? <>{item.bestVehicle + " %"}</> : "NA"}
                        </td>
                        {benchmarkType === 'National' && (
                          <td className={`${styles.tooltipTableCell} ${styles.tooltipValueCell}`}>
                            {item?.national && !isNaN(item?.national) ? <>{item?.national + " %"}</> : "NA"}
                          </td>
                        )}
                        {benchmarkType === 'Depot' && (
                          <td className={`${styles.tooltipTableCell} ${styles.tooltipValueCell}`}>
                            {item?.depo && !isNaN(item?.depo) ? <>{item?.depo + " %"}</> : "NA"}
                          </td>
                        )}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="modal-footer p-2">
              <button type="button" className="btn ms_btn btn-default MS_button" data-dismiss="modal">
                CLOSE
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TooltipTableModal;

// import React from 'react';
// import Plot from 'react-plotly.js';

// const WaterfallChart = () => {
//   const labels = [
//     'Average<br>Speed',
//     'Vehicle<br>Speed<br>Distribution',
//     'Acc.<br>Pedal<br>Position',
//     'Harsh<br>Acceleration',
//     'Harsh<br>Braking',
//     'Rash<br>Turning',
//     'Over<br>speeding',
//     'Driving<br>Score',
//     'Idling',
//     'Coasting',
//     'Regen<br>eration',
//     'RPM'
//   ];

//   const values = [-0.15, 0.08, -0.12, -0.18, -0.25, -0.10, -0.20, 0.45, -0.30, 0.15, 0.25, 0.08];

//   // Colors for bars and text
//   const barColors = values.map(val => (val >= 0 ? 'green' : 'crimson'));
//   const labelsAbove = values.map(val => (val >= 0 ? `+${val.toFixed(2)}` : `${val.toFixed(2)}`));
//   const textColors = values.map(val => (val >= 0 ? 'green' : 'crimson'));

//   return (
//     <div style={{ width: '100%' }}>
//       <Plot
//         data={[
//           {
//             type: 'bar',
//             x: labels,
//             y: values,
//             marker: { color: barColors },
//             text: labelsAbove,
//             textposition: 'outside',
//             hoverinfo: 'x+y',
//             textfont: {
//               color: textColors,
//               size: 14,
//             },
//           }
//         ]}
//         layout={{
//           barmode: 'relative',
//           bargap: 0.3,
//           autosize: true,
//           xaxis: {
//             tickangle: 0,
//             automargin: true,
//             tickfont: {
//               size: 12,
//             },
//           },
//           yaxis: {
//             showticklabels: false,
//             showgrid: false,
//             zeroline: false, // remove default zero line
//           },
//           shapes: [
//             {
//               type: 'line',
//               xref: 'paper',
//               x0: 0,
//               x1: 1,
//               yref: 'y',
//               y0: 0,
//               y1: 0,
//               line: {
//                 color: 'gray',
//                 width: 1,
//                 dash: 'dot', // dashed X axis line
//               },
//             }
//           ],
//           margin: {
//             t: 30,
//             b: 100,
//             l: 30,
//             r: 30,
//           },
//         }}
//         useResizeHandler={true}
//         style={{ width: '100%', height: '100%' }}
//         config={{ responsive: true, displayModeBar: false, staticPlot: true }}
//       />
//     </div>
//   );
// };

// export default WaterfallChart;






